import { useState, useEffect } from 'react';
import { db, collection, onSnapshot } from '../firebase';
import { products as staticProducts } from '../data';

/**
 * useProducts — merges static data.js products with
 * any admin-added products stored in Firestore.
 * Real-time: updates instantly when admin adds/edits/deletes.
 */
export function useProducts() {
  const [fbProducts,  setFbProducts]  = useState([]);
  const [fbLoading,   setFbLoading]   = useState(true);
  const [fbError,     setFbError]     = useState(null);

  useEffect(() => {
    let unsub;
    try {
      unsub = onSnapshot(
        collection(db, 'products'),
        (snap) => {
          const items = snap.docs.map(d => ({
            ...d.data(),
            id:     d.id,          // Firestore doc ID (string)
            fireId: d.id,
            fromFirebase: true,
          }));
          setFbProducts(items);
          setFbLoading(false);
        },
        (err) => {
          console.warn('Firestore products error:', err.message);
          setFbError(err.message);
          setFbLoading(false);
        }
      );
    } catch (err) {
      console.warn('Could not connect to Firestore:', err.message);
      setFbLoading(false);
    }
    return () => unsub && unsub();
  }, []);

  // Merge: static products first, then Firebase products appended
  // Firebase products added by admin appear at the top (newest)
  const allProducts = [
    ...fbProducts,          // admin-added first (newest)
    ...staticProducts,      // then the built-in catalog
  ];

  return { products: allProducts, fbProducts, fbLoading, fbError };
}
